import React, { useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import styles from "./ListingImages.module.css";

const ListingImages = ({ listing }) => {
  const [showGallery, setShowGallery] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  // Format images for the ImageGallery component
  const images = listing.propertyImages.map((image) => ({
    original: image.image_url,
    thumbnail: image.image_url,
  }));

  // Handle clicking outside the gallery to close
  const handleOverlayClick = (event) => {
    if (event.target.className.includes(styles.galleryOverlay)) {
      setShowGallery(false);
    }
  };

  // Open gallery with specific image
  const openGalleryWithIndex = (index) => {
    setStartIndex(index);
    setShowGallery(true);
  };

  // Handle "See all photos" button click
  const handleSeeAllPhotos = (e) => {
    e.stopPropagation(); // Prevent the thumbnail click event
    openGalleryWithIndex(0);
  };

  return (
    <>
      <div className={styles.listingImagesContainer}>
        {/* Main large image on the left */}
        <div className={styles.mainImageContainer}>
          {/* <div className={styles.statusBadge}>Off market</div> */}
          <img
            src={listing.propertyImages[0]?.image_url}
            alt="Main Property View"
            className={styles.mainImage}
            onClick={() => openGalleryWithIndex(0)}
          />
        </div>
        
        {/* Grid of smaller images on the right */}
        <div className={styles.thumbnailGrid}>
          {listing.propertyImages.slice(1, 5).map((image, index) => (
            <div 
              key={index}
              className={styles.thumbnailItem}
              onClick={() => openGalleryWithIndex(index + 1)}
            >
              <img 
                src={image.image_url} 
                alt={`Property View ${index + 2}`}
                className={styles.thumbnailImage}
              />
              {index === 3 && listing.propertyImages.length > 5 && (
                <div className={styles.morePhotosOverlay} onClick={handleSeeAllPhotos}>
                  <div className={styles.morePhotosText}>
                    See all {listing.propertyImages.length} photos
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {showGallery && (
        <div
          className={styles.galleryOverlay}
          onClick={handleOverlayClick}
        >
          <div className={styles.galleryContent}>
            <button
              className={styles.closeButton}
              onClick={() => setShowGallery(false)}
            >
              Close
            </button>
            <ImageGallery 
              items={images} 
              startIndex={startIndex}
              showPlayButton={false}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ListingImages;
